import { text_mod_74 } from "../text/Text.js";

export const module74 = {
  title: "Речення окличні та неокличні",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_74,
    },
  ],
};
